<template>
    <main>
        <div class="container-fluid">
            <div class="mainButton">
                <div class="row">

                    <!-- breadcrumb start -->
                    <div class="col-10">
                        <ul class="nav_breadcrumbs">
                            <li>
                                <router-link to="/modules/home">Home</router-link>
                            </li>
                        </ul>
                    </div>
                    <!-- breadcrumb end -->
                    
                </div>
            </div>
            
        </div>

        <template>
                        <div class="container">
                            <div class="row justify-content-center mt-5">
                                <div class="col-md-12">
                                    <div class="card">
                                        <div class="card-header">
                                            <h5 class="mb-0">Access Denied <i class="fa-solid fa-triangle-exclamation"></i></h5>
                                        </div>
                                        <div class="card-body">
                                            <h3><i class="fa-solid fa-triangle-exclamation"></i> You don't have permission to access this page. Please contact your
                                                administrator.</h3>
                                            <!--<router-link to="/modules/home" class="btn btn-primary">Go to Homepage
                                            </router-link>!-->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>

    </main>
</template>

<script>
    import { ref } from "vue";

    import DashletTable from "@/components/layout/shared/generic/dashlets/DashletTable.vue";
    import DashletGraph from "@/components/layout/shared/generic/dashlets/DashletGraph.vue";
    import DashletCounter from "@/components/layout/shared/generic/dashlets/DashletCounter.vue";
    import DashletChart from "@/components/layout/shared/generic/dashlets/DashletChart.vue";
    import loader from "@/views/shared/loading/Loading.vue";
    import DateFormat from "@/plugins/date_format.js";
    import draggable from 'vuedraggable'

    export default {
        name: "notaccess",
        data() {
            return {
            }
        },
    }
</script>